import React from 'react';
import styled from 'styled-components';

interface Props {
  onChange: () => void;
  status: boolean;
  text: string;
  noBg?: boolean;
}
const Root = styled.div<{ noBg?: boolean }>`
  user-select: none;
  display: flex;
  color: var(--text-primary);
  background-color: ${({ noBg }) => (noBg ? 'transparent' : 'var(--tonal)')};
  border-radius: 0.25rem;
  height: ${({ noBg }) => (noBg ? 'auto' : '2.5rem')};
  align-items: center;
  flex-shrink: 0;

  span {
    padding-left: 0.75rem;
    font-size: 0.875rem;
  }
  > div {
    transition: justify-content 0.5s ease-in-out;
  }
  .flex-start {
    background-color: #c4c4c4;
    outline: 2px solid #c4c4c4;
    div {
      color: #a0a0a0;
    }
  }
  .flex-end {
    background-color: #10bd10;
    outline: 2px solid #10bd10;
    div {
      color: #009b00;
    }
  }
`;

const Switch = styled.div`
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  width: 3rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  margin: 0 0.625rem;
  > div {
    /* outline: 2px solid white; */
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bw-inverse);
    border-radius: 0.25rem;
    width: 2rem;
    height: 1.5rem;
    font-size: 0.75rem;
    letter-spacing: 1;
  }
`;

export default function Toggle({ onChange, status, text, noBg }: Props) {
  return (
    <Root noBg={noBg}>
      {text && <span>{text}</span>}
      <Switch onClick={onChange} role='presentation' className={`${status ? 'flex-end' : 'flex-start'}`} style={noBg ? { marginLeft: 0 } : undefined}>
        <div>{status ? 'ON' : 'OFF'}</div>
        {/* <div /> */}
      </Switch>
    </Root>
  );
}
